import React from "react";
import SectionTitle from "../../../components/section-title";
import BrandMarquee from "../../../components/brand-marquee";

const BrandContainer = () => {
  return (
    <div className="brand-section bg-img">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <SectionTitle
              subTitle="Our Partners"
              title="Our <span>Insurance Partners</span>"
            />
          </div>
        </div>
        <div data-aos="fade-up" data-aos-duration="1200">
          <BrandMarquee />
        </div>
      </div>
    </div>
  );
};

export default BrandContainer;
